var map = {
	"./Anyswap.png": 925,
	"./Anyswap.svg": 926,
	"./Artwork.svg": 927,
	"./Artwork_gmx.svg": 928,
	"./Banxa.png": 929,
	"./DROP_DOWN.svg": 930,
	"./Hop.png": 931,
	"./Hop.svg": 932,
	"./Hop_dark.png": 933,
	"./Hop_dark.svg": 934,
	"./Synapse.png": 935,
	"./Synapse.svg": 936,
	"./binance.png": 937,
	"./bscscan.png": 938,
	"./btn_big_arbitrum.png": 939,
	"./btn_big_avalanche.png": 940,
	"./btn_big_bsc.png": 941,
	"./btn_big_purchasegmx.png": 942,
	"./btn_big_purchasegmx.svg": 943,
	"./buy_gmx.svg": 944,
	"./buy_gmx_bond.svg": 945,
	"./buy_transfer_eth.svg": 946,
	"./coinbaseWallet.png": 947,
	"./coingecko.png": 948,
	"./cross.svg": 949,
	"./ddl/chevron-down.svg": 950,
	"./ddl/chevron-down_sm.svg": 951,
	"./ddl/ic_btc_40.png": 952,
	"./ddl/ic_btc_40.svg": 491,
	"./ddl/ic_dai_40.png": 953,
	"./ddl/ic_dai_40.svg": 492,
	"./ddl/ic_eth_40.png": 954,
	"./ddl/ic_eth_40.svg": 341,
	"./ddl/ic_frax_40.png": 955,
	"./ddl/ic_frax_40.svg": 493,
	"./ddl/ic_link_40.png": 956,
	"./ddl/ic_link_40.svg": 494,
	"./ddl/ic_uni_40.png": 957,
	"./ddl/ic_uni_40.svg": 495,
	"./ddl/ic_usdc_40.png": 958,
	"./ddl/ic_usdc_40.svg": 496,
	"./ddl/ic_usdt_40.png": 959,
	"./ddl/ic_usdt_40.svg": 497,
	"./ddl/ic_weth_40.png": 960,
	"./ddl/ic_weth_40.svg": 498,
	"./ddl/icon_arrow.svg": 961,
	"./ddl/icon_check.svg": 962,
	"./ddl/icon_close.svg": 963,
	"./ddl/icon_close_sm.svg": 964,
	"./ddl/icon_close_toast.svg": 965,
	"./ddl/icon_dollar.svg": 966,
	"./ddl/icon_dollar_active.svg": 967,
	"./ddl/icon_market.svg": 968,
	"./ddl/icon_market_active.svg": 969,
	"./ddl/icon_trigger.svg": 970,
	"./ddl/icon_trigger_active.svg": 971,
	"./ddl/icon_withdraw.svg": 972,
	"./ddl/icon_withdraw_active.svg": 973,
	"./ddl/lock.svg": 974,
	"./ddl/long.svg": 975,
	"./ddl/long_active.svg": 976,
	"./ddl/short.svg": 977,
	"./ddl/short_active.svg": 978,
	"./flag_en.svg": 979,
	"./flag_es.svg": 980,
	"./flag_fr.svg": 981,
	"./flag_ja.svg": 982,
	"./flag_ko.svg": 983,
	"./flag_ru.svg": 984,
	"./flag_zh.svg": 985,
	"./glp_icon.svg": 986,
	"./gmx-logo-final-white-small.png": 987,
	"./gmx-logo-final-white.png": 988,
	"./gmx-logo-final.png": 989,
	"./gmx-logo-glow.png": 990,
	"./gmx-logo-with-name.svg": 991,
	"./gmx_logo.svg": 992,
	"./graphite-01.png": 993,
	"./ic-communityproject.svg": 994,
	"./ic_arbitrum_16.svg": 995,
	"./ic_arbitrum_24.svg": 996,
	"./ic_arbitrum_96.svg": 997,
	"./ic_arbitrum_hover_16.svg": 998,
	"./ic_arrowleft16.svg": 999,
	"./ic_arrowright16.svg": 1000,
	"./ic_avalanche_16.svg": 1001,
	"./ic_avalanche_24.svg": 1002,
	"./ic_avalanche_96.svg": 1003,
	"./ic_avax_24.svg": 1004,
	"./ic_avax_30.svg": 1005,
	"./ic_avax_40.svg": 1006,
	"./ic_banxa.svg": 1007,
	"./ic_binance_logo.svg": 1008,
	"./ic_bsc.svg": 1009,
	"./ic_bsc_96.svg": 1010,
	"./ic_btc.b_24.svg": 1011,
	"./ic_btc.b_40.svg": 1012,
	"./ic_btc_24.svg": 1013,
	"./ic_btc_40.svg": 1014,
	"./ic_busd_24.svg": 1015,
	"./ic_buy_glp.svg": 1016,
	"./ic_cash.png": 1017,
	"./ic_cash.svg": 1018,
	"./ic_checked.svg": 1019,
	"./ic_coingecko_16.svg": 1020,
	"./ic_coingecko_hover_16.svg": 1021,
	"./ic_convert_down.svg": 1022,
	"./ic_copy_16.svg": 1023,
	"./ic_cost.svg": 1024,
	"./ic_dai_24.svg": 1025,
	"./ic_dai_40.svg": 1026,
	"./ic_discord.svg": 1027,
	"./ic_eth_24.svg": 1028,
	"./ic_eth_40.svg": 1029,
	"./ic_frax_24.svg": 1030,
	"./ic_frax_40.svg": 1031,
	"./ic_github.svg": 1032,
	"./ic_glp_24.svg": 1033,
	"./ic_glp_40.svg": 1034,
	"./ic_glp_custom.svg": 1035,
	"./ic_gmx.svg": 1036,
	"./ic_gmx_24.svg": 1037,
	"./ic_gmx_30.svg": 1038,
	"./ic_gmx_40.svg": 1039,
	"./ic_gmx_64.svg": 1040,
	"./ic_gmx_arbitrum.svg": 1041,
	"./ic_gmx_avax.svg": 1042,
	"./ic_gmx_big.svg": 1043,
	"./ic_gmx_custom.svg": 1044,
	"./ic_gmx_footer.svg": 1045,
	"./ic_hop.svg": 1046,
	"./ic_info.svg": 1047,
	"./ic_language24.svg": 1048,
	"./ic_link_24.svg": 1049,
	"./ic_link_40.svg": 1050,
	"./ic_liquidity.svg": 1051,
	"./ic_medium.svg": 1052,
	"./ic_menu_dots.svg": 1053,
	"./ic_metamask_16.svg": 1054,
	"./ic_metamask_hover_16.svg": 1055,
	"./ic_mim_24.svg": 1056,
	"./ic_mim_40.svg": 1057,
	"./ic_multiswap.svg": 1058,
	"./ic_new_link_16.svg": 1059,
	"./ic_olympus.svg": 1060,
	"./ic_olympus_arbitrum.svg": 1061,
	"./ic_selector_dropdowns.svg": 1062,
	"./ic_settings_16.svg": 1063,
	"./ic_settings_24.svg": 1064,
	"./ic_sign in_16.svg": 1065,
	"./ic_sign_out_16.svg": 1066,
	"./ic_simpleswaps.svg": 1067,
	"./ic_stats.svg": 1068,
	"./ic_stats_big.svg": 1069,
	"./ic_synapse.svg": 1070,
	"./ic_telegram.svg": 1071,
	"./ic_tether_24.svg": 1072,
	"./ic_tokens.svg": 1073,
	"./ic_totaluser.svg": 1074,
	"./ic_trading.svg": 1075,
	"./ic_transfer_avax.svg": 1076,
	"./ic_twitter.svg": 1077,
	"./ic_uni_24.svg": 1078,
	"./ic_uni_40.svg": 1079,
	"./ic_usdc.e_24.svg": 1080,
	"./ic_usdc.e_40.svg": 1081,
	"./ic_usdc_24.svg": 1082,
	"./ic_usdc_40.svg": 1083,
	"./ic_usdt_24.svg": 1084,
	"./ic_usdt_40.svg": 1085,
	"./ic_wallet_24.svg": 1086,
	"./ic_wavax_24.svg": 1087,
	"./ic_wavax_40.svg": 1088,
	"./ic_weth_24.svg": 1089,
	"./ic_weth_40.svg": 1090,
	"./lg_arbitrum.svg": 1091,
	"./logo_GMX.svg": 1092,
	"./logo_GMX_small.svg": 1093,
	"./long.svg": 1094,
	"./metamask-text.svg": 1095,
	"./metamask.png": 1096,
	"./page-not-found.svg": 1097,
	"./position-share-bg.png": 1098,
	"./short.svg": 1099,
	"./swap.svg": 1100,
	"./trading.jpg": 1101,
	"./wallet-connect-text.svg": 1102,
	"./walletconnect-circle-blue.svg": 1103,
	"./wave-01.png": 1104,
	"./wave-02.png": 1105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;